import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/settings",
  account: "/settings/account",
  plans: "/settings/plans",
  membership: "/settings/membership",
};
